import React, { Fragment } from 'react'
import './index.scss'

const SubText = (props) => {
    const textArr = props.subTexts;
    return (
        <Fragment>
            {
                textArr.map((item, index) => (<p key={index} className="sub-text">{item}</p>))
            }
        </Fragment>
    )
}

const Links = (props) => {
    const linkArr = props.links;
    return (
        <Fragment>
            {
                linkArr.map((item, index) => (<a target="_blank" href={item.href} >{item.link}</a>))
            }
        </Fragment>
    )
}

const ContentsPart = (porps) => {
    const contentArr = porps.contents;
    return (
        <Fragment>
            {
                contentArr.map((item, index) => {
                    return (
                        <li key={index}>
                            {item.text && <span>{item.text}</span>}{item.link && item.href && <a rel="noopener noreferrer" target="_blank" href={item.href}>{item.link}</a>}{item.links && <Links links={item.links} />}
                            {item.subTexts && <SubText subTexts={item.subTexts} />}{item.imgSrc && <img className="main-img" src={item.imgSrc} alt={item.imgText} />}
                        </li>
                    )
                })
            }
        </Fragment>
    )
}

const DocPart = (props) => {
    const infoArr = props.infos;
    return (
        <div className="DocPart">
            {
                infoArr.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            <h2 className="title">{item.title}{item.rightTitle && <p className="right-title">{item.rightTitle}</p>}</h2>
                            <ul className="contents">
                                {item.contents && <ContentsPart contents={item.contents} />}
                            </ul>
                        </Fragment>
                    )
                })
            }
        </div>
    )
}

export default DocPart;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/DocPart/index.js